<template lang="pug">
  footer.footer
    .container
      .content.has-text-centered
        .columns
          .column.is-12
            span Hecho con 💚 por: &nbsp
            a(href="https://twitter.com/MichiwooWebs" target='_blank')
              span.has-text-grey-dark &nbsp@michiwoo&nbsp
              font-awesome-icon.has-text-grey-dark(:icon="{ prefix: 'fab', iconName: 'twitter' }")
            a(href="https://github.com/MichiWoo/" target='_blank')
              | &nbsp
              font-awesome-icon.has-text-grey-dark(:icon="{ prefix: 'fab', iconName: 'github' }")
        .columns.is-mobile.is-multiline
          .column.is-12-mobile
            a(href="https://www.paypal.me/MICHIWOOWEBS" target='_blank')
              span.has-text-grey-dark Invítame un cafe&nbsp
              font-awesome-icon.has-text-grey(:icon="{ prefix: 'fas', iconName: 'coffee' }")


</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="css" scoped>
  .footer {
    height: 13vh;
    width: 100%;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    position: fixed;
    bottom: 0px;
    z-index: 1000;
  }
  .columns {
    margin-bottom: 0;
  }
</style>
